import React from 'react'
import MarginAnalysis from './MarginAnalysis'

const MarginAnalysisEventPlanning = props => {
  return <MarginAnalysis {...props} isEventPlanner />
}

export default MarginAnalysisEventPlanning
